import CompanyInvoiceTab from "./sections/CompanyInvoiceTab.jsx";
import CompanyDetailsTab from "./sections/CompanyDetailsTab.jsx";
import { getSettings, getAllBooth, editSettings } from "../../api/companyInfo/index.js";
/* eslint-disable react-hooks/exhaustive-deps */
import { Alert, Box, Button, Checkbox, CircularProgress, FormControlLabel, Grid, Paper, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Dropdown, PageTitle, TextEditor } from "../../../../shared/ui/common/index.js";



import { logout } from "../../../../shared/state/slices/user.js";
import Logos from "./logos.jsx";
import SiteLink from "./siteLink.jsx";
import Social from "./social.jsx";

const CompanyInfo = () => {
  const { token } = useSelector((state) => state.user);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [loadingSumbit, setLoadingSumbit] = useState(false);
  const [data, setData] = useState({});
  const [loadError, setLoadError] = useState("");
  const [loadAttempt, setLoadAttempt] = useState(0);
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [allBooth,setAllBooth] = useState([])
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setLoading(true);
    setLoadError("");
    getSettings(token)
      .then((res) => {
        const { data } = res;
        setLoading(false);
        if (data && data.code === 200 && data.data) {
          setData(data.data);
        } else {
          setLoadError("پاسخ تنظیمات معتبر نیست؛ دوباره تلاش کنید.");
        }
      })
      .catch((err) => {
        setLoadError("دریافت تنظیمات انجام نشد؛ دوباره تلاش کنید.");
        if (err.response?.status === 401 || err.response?.status === 403) {
          dispatch(logout());
        }
        setLoading(false);
      });
    getAllBooth(token)
      .then((res) => {
        const { data } = res;
        if (data && data.code === 200 && data.data) {
          setAllBooth(data.data);
        }
      })
      .catch((err) => {
        if (err.response?.status === 401 || err.response?.status === 403) {
          dispatch(logout());
        }
      });
  }, [id, token, loadAttempt]);
  const submitEdit = () => {
    if (loading || loadError) return;
    setLoadingSumbit(true);

    editSettings(data, token)
      .then((res) => {
        toast.success("با موفقیت ویرایش شد");
        setLoadingSumbit(false);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
        setLoadingSumbit(false);
        if (err.response?.status === 401 || err.response?.status === 403) {
          dispatch(logout());
        }
      });
  };

  return (
    <>
      <PageTitle
        broadCrumb={[
          {
            title: "   تنظیمات",
            path: "/companyInfo",
          },
        ]}
        title="  مشخصات شرکت "
      />
      <div className="md:mx-3 mx-1">
        {loadError && <Alert severity="error" action={<Button onClick={() => setLoadAttempt((value) => value + 1)}>تلاش مجدد</Button>}>{loadError}</Alert>}
        <Paper sx={{ border: "1px solid #dbdfea", mb: 1 }} elevation={0}>
          <Box
            sx={{ borderBottom: 1, borderColor: "divider" }}
            className="relative z-10"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              sx={{
                flexGrow: 1,
                height: "3.07rem",
                minHeight: "40px !important",
                ".MuiTab-root": {
                  minHeight: "40px !important",
                },
                background: (theme) =>
                  theme.palette.mode === "light"
                    ? "rgba(0,0,0,0.04) !important"
                    : "rgba(0,0,0,0.7)  !important",
              }}
            >
              <Tab label=" مشخصات شرکت / مجموعه " {...a11yProps(0)} />
              <Tab label=" لوگو  " {...a11yProps(1)} />
              {/*   <Tab label="  لوگو فوتر " {...a11yProps(2)} /> */}
              <Tab label="   صفحات مرتبط " disabled={loading || Boolean(loadError)} {...a11yProps(2)} />
              <Tab label="  شبکه های اجتماعی   " {...a11yProps(3)} />
              <Tab label="   تنظیمات  کلی  " {...a11yProps(4)} />
              {/*       <Tab label="   لینک های اپلیکیشن  " {...a11yProps(5)} /> */}
              {/*       <Tab label="     تنظیمات طرح ها و مالیات   " {...a11yProps(6)} /> */}
            </Tabs>
          </Box>
          <CompanyDetailsTab TabPanel={TabPanel} value={value} loading={loading} data={data} setData={setData} submitEdit={submitEdit} loadingSumbit={loadingSumbit} />
          <TabPanel value={value} index={1}>
            <Logos data={data} />
          </TabPanel>
          {/*      <TabPanel value={value} index={2}>
            <FooterLogos />
          </TabPanel> */}
          <TabPanel value={loading ? -1 : value} index={2}>
            <>
              <div className="justify-between flex gap-3 flex-wrap items-center">
                <h1 className="my-5 font-bold text-xl">قوانین سایت : </h1>
                <a
                  href={`${process.env.REACT_APP_DOMAIN_URL}/terms-and-conditions`}
                  target={"_blank"}
                  rel="noreferrer"
                  className="text-base font-bold"
                >
                  terms-and-conditions/
                </a>
              </div>

              <TextEditor
                value={data?.siteRules}
                change={(e) => setData((current) => ({ ...current, siteRules: e }))}
                hint=" قوانین سایت"
              />
            </>
            <div className="justify-between flex gap-3 flex-wrap items-center mt-10">
              <h1 className="my-5 font-bold text-xl">حریم شخصی : </h1>{" "}
              <a
                href={`${process.env.REACT_APP_DOMAIN_URL}/privacy-and-policy`}
                target={"_blank"}
                className="text-base font-bold"
                rel="noreferrer"
              >
                privacy-and-policy/
              </a>
            </div>
            <TextEditor
              value={data?.privacyPolicy}
              change={(e) => setData((current) => ({ ...current, privacyPolicy: e }))}
              hint="  حریم  شخصی"
            />

            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
                mt: 4,
              }}
            >
              <Button
                onClick={submitEdit}
                variant="contained"
                disabled={loadingSumbit}
                sx={{ width: { xs: "100%", sm: "auto" } }}
              >
                {loadingSumbit ? <CircularProgress /> : <>ثبت اطلاعات</>}
              </Button>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Social data={data} setData={setData} />
            <div className="flex justify-end w-full mt-7">
              <Button
                onClick={submitEdit}
                variant="contained"
                disabled={loadingSumbit}
                sx={{ width: { xs: "100%", sm: "auto" } }}
              >
                {loadingSumbit ? <CircularProgress /> : <>ثبت اطلاعات</>}
              </Button>
            </div>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <div className="flex flex-wrap gap-3">
              <FormControlLabel
                control={<Checkbox checked={Boolean(data?.autoValidation)} />}
                onChange={() => {
                  setData({ ...data, autoValidation: !data?.autoValidation });
                }}
                label={
                  <h2 className=" text-[0.78rem]"> ارسال آگهی بدون تایید</h2>
                }
              />{" "}
              <div className="md:max-w-[16rem] w-full">
                {" "}
                <Dropdown
                  title={"غرفه پشتیبان "}
                  data={allBooth}
                  value={allBooth?.find((item) => item?.id === data?.contactBoothId)}
                  change={(e) => {
                    setData({ ...data, contactBoothId: e.id });
                  }}
                />
              </div>
            </div>

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={submitEdit}
                variant="contained"
                disabled={loadingSumbit}
                sx={{ width: { xs: "100%", sm: "auto" } }}
              >
                {loadingSumbit ? <CircularProgress /> : <>ثبت اطلاعات</>}
              </Button>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={5}>
            <SiteLink />
          </TabPanel>
          <CompanyInvoiceTab TabPanel={TabPanel} value={value} data={data} setData={setData} submitEdit={submitEdit} loadingSumbit={loadingSumbit} />
        </Paper>
      </div>
    </>
  );
};

export default CompanyInfo;
function a11yProps(index) {
  return {
    id: `company-tab-${index}`,
    "aria-controls": `company-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}
var planData = [
  { id: 0, title: "فاکتور" },
  { id: 1, title: "کیف پول" },
];
